import { Field } from "sparkson";

export class Soundtrack {
  constructor(
    @Field("u", true) public musicUrl: string,
    @Field("so", true) public startOffset: number = 0,
    @Field("eo", true) public endOffset: number = 0,
    @Field("fid", true) public fadeInDuration: number = 0,
    @Field("fod", true) public fadeOutDuration: number = 1500,
  ) {
    this.changeMillisecondsToSeconds();
  }

  private changeMillisecondsToSeconds() {
    this.startOffset /= 1000;
    this.endOffset /= 1000;
    this.fadeInDuration /= 1000;
    this.fadeOutDuration /= 1000;
  }
}
